import { useState, useEffect } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputPESEL from "../../helpers/InputPESEL";
import InputDate from "../../helpers/InputDate";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";
import InputCombo from "../../helpers/InputCombo";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputPostCode from "../../helpers/InputPostCode";
import InputNIP from "../../helpers/InputNIP";

import back from "../../back.png";

function KidNew(props)
{

    const [limitTab, setLimitTab] = useState(null);
    const [bankTab, setBankTab] = useState(null);

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [row, setRowX] = useState({

        rodzenstwo: "",
    

        p_grupa_id: '_x_',
        imie:  "",        
        imie2:  "",    
        nazwisko: "",
        pesel: "",
        data_urodzenia: "",
        miejsce_urodzenia: "",
        ulica: "",
        nr_domu: "",
        nr_mieszkania: "",
        kod_pocztowy: "",
        miasto: "",

        kr_nazwa: "",
        kr_ulica: "",
        kr_nr_domu: "",
        kr_nr_mieszkania: "",
        kr_kod_pocztowy: "",
        kr_miasto: "",

        
        info: "",
        wazne_informacje: "",
        info_catering: "",
        info_e: "",

        publikacja_wizerunku: "0",
        publikacja_wizerunku_info: "",


        rdz1_id: -1,
        rdz1_imie: "",
        rdz1_nazwisko: "",
        rdz1_email: "",
        rdz1_telefon: "",
        rdz1_pesel: "",
        rdz1_nr_dowodu: "",
        rdz1_nip: "",

        rdz2_id: -1,
        rdz2_imie: "",
        rdz2_nazwisko: "",
        rdz2_email: "",
        rdz2_telefon: "",
        rdz2_pesel: "",
        rdz2_nr_dowodu: "",
        rdz2_nip: "",

        op_select: "1",
        uq_numer_rachunku_op: '0',
        uq_numer_klienta: '',
        uq_bank: '',
        uq_numer_rodzica: '[AUTO]',

        info_dodatkowe_na_fakturze: '',



    });
    var tmpRow = row;


    const [checked, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked);
      };

      const [checked1, setChecked1] = useState(false);
      const handleChange1= () => {
          setChecked1(!checked1);
        };      

      const [checked2, setChecked2] = useState(false);
      const handleChange2 = () => {
          setChecked2(!checked2);
        };    
        


      const [checkedR1, setCheckedR1] = useState(false);
      const handleChangeR1 = () => {
            setCheckedR1(!checkedR1);
          };     
          
      const [checkedR2, setCheckedR2] = useState(false);
      const handleChangeR2 = () => {
                setCheckedR2(!checkedR2);
              };              
        
      const [checked3, setChecked3] = useState(false);
      const handleChange3 = () => {
                  setChecked3(!checked3);
                };        


      var optionSaldo = [
        {
            v: '_x_',
            title: 'Wybierz'
        },
        {
            v: '1',
            title: 'Opiekun lub rodzic nr 1'
        },
        {
            v: '2',
            title: 'Opiekun lub rodzic nr 2'
        },
      ];


      var optionRach = [       
        {
            v: '0',
            title: 'Pomiń - Brak umowy z bankiem'
        },
        {
            v: '1',
            title: 'Tak - indywidualny numer rachunku do wpłat'
        },
      ];


    const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = "";

            tmpRow[tabName] = tRef;     
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  

            //setRowX( {...row, [tabName]:tRef } );   
            return;
        }

      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         

        if(  filedName == 'imie' || filedName == 'nazwisko' ) 
        {
           tmpRow["kr_nazwa"] =  tmpRow["imie"]+" " +  tmpRow["nazwisko"] ;
           tmpRow["kr_nazwa_valid"] = true; 
        }


        if(filedName == 'nr_domu') 
        {
           tmpRow["kr_nr_domu"] =  tmpRow["nr_domu"]+" " ;
           tmpRow["kr_nr_domu_valid"] = true; 
        }

        if(filedName == 'nr_mieszkania') 
        {
           tmpRow["kr_nr_mieszkania"] =  tmpRow["nr_mieszkania"]+" " ;
           tmpRow["kr_nr_mieszkania_valid"] = true; 
        }

        if(filedName == 'ulica') 
        {
           tmpRow["kr_ulica"] =  tmpRow["ulica"]+" " ;
           tmpRow["kr_ulica_valid"] = true; 
        }

        if(filedName == 'kod_pocztowy') 
        {
           tmpRow["kr_kod_pocztowy"] =  tmpRow["kod_pocztowy"]+" " ;
           tmpRow["kr_kod_pocztowy_valid"] = true; 
        }

        if(filedName == 'miasto') 
        {
           tmpRow["kr_miasto"] =  tmpRow["miasto"]+" " ;
           tmpRow["kr_miasto_valid"] = true; 
        }


        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }


    const infoLimit = () => {

 
        props.mainView.setProgress(-2);

      
 

        var req = row;

        fetch( Config.url + '/rest_v1_kids,info_limit', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                         setLimitTab(res.result);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 
      const infoBank = () => {

 
        props.mainView.setProgress(-2);

      
 

        var req = row;

        fetch( Config.url + '/rest_v1_kids,info_bank', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);                    

                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                         setBankTab(res.result);

 
                          tmpRow["uq_numer_rachunku_op"] = res.result.numer_rach_auto_uq;
                          tmpRow["uq_numer_rachunku_op_valid"] = true;      

             

                          if(res.result.numer_rach_auto_uq == '1')
                          {
                           
                            tmpRow["uq_bank"] = res.result.numer_rach_uq_bank;
                            tmpRow["uq_bank_valid"] = true;  

                            tmpRow["uq_numer_klienta"] = res.result.numer_rach_uq_klient;
                            tmpRow["uq_numer_klienta_valid"] = true;  
                          }

                          setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  



                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }

    
    const saveData = () => {


         
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

      

        

        var req = row;

        fetch( Config.url + '/rest_v1_kids,kid_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Dziecko zostało dodane", "ok" , null);         
                        
                        Config.removeFromBuffer( Config.cache_kids_search, props.userData );
                        
                        props.onBack();
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 

    const kidSelected = (id) => {

      //  console.log("Kid Selected " + id);

        //pobierz dane rodzicow...
        props.mainView.setProgress(-2);

        var req = {
            p_dziecko_id: id
        };



        fetch( Config.url + '/rest_v1_kids,get_parents', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else                 
                    if(res.status != undefined && res.status == "OK")
                    {
                          
                            if(res.result.r1 != null && res.result.r1 != undefined &&   res.result.r1.id > 0  )
                            {
                             

                                   if(res.result.r1.imie.length > 0 && res.result.r2.imie.length > 0  )
                                   {
                                       props.mainView.showDialog( "Powiadomienie", "Znaleziono rodziców: " + res.result.r1.imie + " " + res.result.r1.nazwisko  + " oraz " + res.result.r2.imie + " " + res.result.r2.nazwisko + ". Powiązać rodziców z nowym dzieckiem?" , "yesno" , (param)=>{


                                        
                                        if(param == "yes")
                                            {
                                                        setRowX({...row,
                                                            ["rdz1_id"]:res.result.r1.id,      
                                                            ["rdz1_imie"]:res.result.r1.imie,    
                                                            ["rdz1_nazwisko"]:res.result.r1.nazwisko,    
                                                            ["rdz1_telefon"]:res.result.r1.telefon_kontaktowy,    
                                                            ["rdz1_email"]:res.result.r1.e_mail_kontakt,  
        
                                                            ["rdz2_id"]:res.result.r2.id,      
                                                            ["rdz2_imie"]:res.result.r2.imie,    
                                                            ["rdz2_nazwisko"]:res.result.r2.nazwisko,    
                                                            ["rdz2_telefon"]:res.result.r2.telefon_kontaktowy,    
                                                            ["rdz2_email"]:res.result.r2.e_mail_kontakt,  
                                                });
                                            }


                                       } );                                           
                                   }else
                                   {
                                       props.mainView.showDialog( "Powiadomienie", "Znaleziono: " + res.result.r1.imie + " " + res.result.r1.nazwisko + ". Powiązać rodziców z nowym dzieckiem?" , "yesno" , ( param ) => {


                                        if(param == "yes")
                                            {
                                                        setRowX({...row,
                                                            ["rdz1_id"]:res.result.r1.id,      
                                                            ["rdz1_imie"]:res.result.r1.imie,    
                                                            ["rdz1_nazwisko"]:res.result.r1.nazwisko,    
                                                            ["rdz1_telefon"]:res.result.r1.telefon_kontaktowy,    
                                                            ["rdz1_email"]:res.result.r1.e_mail_kontakt,  
        
                                                            ["rdz2_id"]:res.result.r2.id,      
                                                            ["rdz2_imie"]:res.result.r2.imie,    
                                                            ["rdz2_nazwisko"]:res.result.r2.nazwisko,    
                                                            ["rdz2_telefon"]:res.result.r2.telefon_kontaktowy,    
                                                            ["rdz2_email"]:res.result.r2.e_mail_kontakt,  
                                                });
                                            }

                                       } );  
                                   }
                            }

                            


                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });


    }


    if(limitTab == null)
    {
        infoLimit();
        
    }else
    {
        if(limitTab.max <= limitTab.now )
        {          
            props.onBack();

            props.mainView.showDialog( "O nie!", "Nie możesz dodać więcej dzieci, limit: " + limitTab.max + ", wykorzystano:  " + limitTab.now + "\n" , "ok" , (p)=> {
                document.location.href = "/module/home/view/pay";
            } );  

           
        }
    }

    if(bankTab == null)
    {
        setBankTab([]);
        infoBank();        
    }


    return (

            <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>


                    <form className="eForm bg_center">

                        

                            <div className="form_tab">
                                    <div className="form_tab_title amount_minus ">Rodzeństwo (podaj, by powiązać konta rodziców - ZALECANE):</div>

                                    <div className="form_control">
                                                <div className="fieldName">Imię i nazwisko dziecka, które <u className="amount_minus">już chodzi</u> do placówki*</div>
                                                <InputSearchKid  archiwalne={0} mainView={props.mainView} userData={props.userData} value={row.rodzenstwo} err={errTab} kidSelected={kidSelected} valChange={valChangeListener} goNext={goNextNew} name="rodzenstwo" placeholder={"Imię i nazwisko:"} className=' w300 ' req='0' firstUp="1" />
                                    </div>
                                    <div  className="amount_minus">
                                        Uwaga: Jeśli nowe dziecko ma rodzeństwo w tej placówce to wskaż je powyżej. Dzięki temu rodzice będą mogli się wygodnie przełączać pomiędzy profilami dziecka bez konieczności logowania na inne konto.   
                                    </div>
                            </div>


                            <div className="form_tab">


                                   <div className="form_tab_title">Nowe dziecko:

                                           &nbsp; 
                                           <label className="switch" title={props.userData.dic.showmore}>                               
                                                <input type="checkbox" checked={checked}  onChange={handleChange}/>
                                                <span className="slider round"></span>
                                           </label>  
                                   </div>

                                   
                                

                                    
                                    <div className="form_control">
                                                <div className="fieldName">Grupa*</div>
                                                <InputComboGrupa mainView={props.mainView}   userData={props.userData} value={row.p_grupa_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Grupa:"} className='  ' req='1'   />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Imię*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię:"} className=' w100 ' req='1' firstUp="1" />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Drugie imię</div>
                                                <InputTextAlpha   userData={props.userData} value={row.imie2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie2" placeholder={"Drugie imię:"} className=' w100 ' req='0' firstUp="1" />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Nazwisko*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='1' firstUp="1" />
                                    </div>



                                    { checked &&
                                    <div>
                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">PESEL</div>
                                                        <InputPESEL  userData={props.userData} value={row.pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pesel" placeholder={"PESEL:"} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Data urodzenia</div>
                                                        <InputDate  userData={props.userData} value={row.data_urodzenia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_urodzenia" placeholder={"Data urodzenia:"} className=' w150 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Miejsce urodzenia</div>
                                                        <InputText  userData={props.userData} value={row.miejsce_urodzenia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="miejsce_urodzenia" placeholder={"Miejsce urodzenia:"} className=' w200 ' req='0'  />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Ulica</div>
                                                        <InputText  userData={props.userData} value={row.ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ulica" placeholder={"Ulica:"} className=' w200 ' req='0'  />
                                            </div>
        
                                            <div className="form_control">
                                                        <div className="fieldName">Nr domu</div>
                                                        <InputText  userData={props.userData} value={row.nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_domu" placeholder={"Nr domu:"} className=' w50 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Nr mieszkania</div>
                                                        <InputText  userData={props.userData} value={row.nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w50 ' req='0'  />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputPostCode  userData={props.userData} value={row.kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputText  userData={props.userData} value={row.miasto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="miasto" placeholder={"Miasto:"} className=' w200 ' req='0'  />
                                            </div>
                                    </div>
                                    }

                            </div>



                            <div className="form_tab">


                                    <div className="form_tab_title">Dane opiekun lub rodzica nr 1:

                                            &nbsp; 
                                            <label className="switch" title={props.userData.dic.showmore}>                               
                                                <input type="checkbox" checked={checkedR1}  onChange={handleChangeR1}/>
                                                <span className="slider round"></span>
                                            </label>  
                                    </div>



 

                                    <div className="form_control">
                                                <div className="fieldName">Imię*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.rdz1_imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_imie" placeholder={"Imię:"} className=' w100 ' req='1' firstUp="1" />
                                    </div> 

                                    <div className="form_control">
                                                <div className="fieldName">Nazwisko*</div>
                                                <InputTextAlpha   userData={props.userData} value={row.rdz1_nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='1' firstUp="1" />
                                    </div>


                                    <div className="form_control">
                                                <div className="fieldName">Telefon (zalecane)</div>
                                                <InputPhone   userData={props.userData} value={row.rdz1_telefon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_telefon" placeholder={"Telefon:"} className=' w100 ' req='0'  />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">E-mail (zalecane)</div>
                                                <InputEmail   userData={props.userData} value={row.rdz1_email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_email" placeholder={"E-mail:"} className=' w200 ' req='0'  />
                                    </div>


                                    { checkedR1 &&
                                    <div>
                                            <div className="form_split"></div>


                                            <div className="form_control">
                                                <div className="fieldName">PESEL</div>
                                                <InputPESEL  userData={props.userData} value={row.rdz1_pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_pesel" placeholder={"PESEL:"} className=' w100 ' req='0' />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">Nr dowodu</div>
                                                <InputText  userData={props.userData} value={row.rdz1_nr_dowodu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_nr_dowodu" placeholder={"Nr dowodu:"} className=' w100 ' req='0' />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">NIP</div>
                                                <InputNIP  userData={props.userData} value={row.rdz1_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz1_nip" placeholder={"NIP:"} className=' w100 ' req='0' />
                                            </div>


                                    </div>
                                    }

                                    </div>



                            <div className="form_tab">


                                    <div className="form_tab_title">Dane opiekun lub rodzica nr 2 (jeśli nie ma wpisz BRAK):

                                            &nbsp; 
                                            <label className="switch" title={props.userData.dic.showmore}>                               
                                                <input type="checkbox" checked={checkedR2}  onChange={handleChangeR2}/>
                                                <span className="slider round"></span>
                                            </label>  
                                    </div>





                                    <div className="form_control">
                                                <div className="fieldName">Imię</div>
                                                <InputTextAlpha   userData={props.userData} value={row.rdz2_imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_imie" placeholder={"Imię:"} className=' w100 ' req='0' firstUp="1" />
                                    </div> 

                                    <div className="form_control">
                                                <div className="fieldName">Nazwisko</div>
                                                <InputTextAlpha   userData={props.userData} value={row.rdz2_nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='0' firstUp="1" />
                                    </div>


                                    <div className="form_control">
                                                <div className="fieldName">Telefon (zalecane)</div>
                                                <InputPhone   userData={props.userData} value={row.rdz2_telefon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_telefon" placeholder={"Telefon:"} className=' w100 ' req='0'  />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">E-mail (zalecane)</div>
                                                <InputEmail   userData={props.userData} value={row.rdz2_email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_email" placeholder={"E-mail:"} className=' w200 ' req='0'  />
                                    </div>


                                    { checkedR2 &&
                                    <div>
                                            <div className="form_split"></div>


                                            <div className="form_control">
                                                <div className="fieldName">PESEL</div>
                                                <InputPESEL  userData={props.userData} value={row.rdz2_pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_pesel" placeholder={"PESEL:"} className=' w100 ' req='0' />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">Nr dowodu</div>
                                                <InputText  userData={props.userData} value={row.rdz2_nr_dowodu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_nr_dowodu" placeholder={"Nr dowodu:"} className=' w100 ' req='0' />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">NIP</div>
                                                <InputNIP  userData={props.userData} value={row.rdz2_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rdz2_nip" placeholder={"NIP:"} className=' w100 ' req='0' />
                                            </div>


                                    </div>
                                    }

                                    </div>






                            <div className="form_tab">


                                    <div className="form_tab_title">Adres do korespondencji:

                                            &nbsp; 
                                            <label className="switch" title={props.userData.dic.showmore}>                               
                                                <input type="checkbox" checked={checked1}  onChange={handleChange1}/>
                                                <span className="slider round"></span>
                                            </label>  
                                    </div>



 


                                    { checked1 &&
                                    <div>
                                            
                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Imię i nazwisko / Nazwa / Nazwa firmy</div>
                                                        <InputText  userData={props.userData} value={row.kr_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_nazwa" placeholder={"Nazwa:"} className=' w300 ' req='0'  />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Ulica</div>
                                                        <InputText  userData={props.userData} value={row.kr_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_ulica" placeholder={"Ulica:"} className=' w200 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Nr domu</div>
                                                        <InputText  userData={props.userData} value={row.kr_nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_nr_domu" placeholder={"Nr domu:"} className=' w50 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Nr mieszkania</div>
                                                        <InputText  userData={props.userData} value={row.kr_nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w50 ' req='0'  />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputText  userData={props.userData} value={row.kr_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_kod_pocztowy" placeholder={"Nr mieszkania:"} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputText  userData={props.userData} value={row.kr_miasto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kr_miasto" placeholder={"Nr mieszkania:"} className=' w100 ' req='0'  />
                                            </div>
                                    </div>
                                    }

                                    </div>



                            <div className="form_tab">


                                    <div className="form_tab_title">Informacje dodatkowe:
                                          &nbsp; 
                                           <label className="switch" title={props.userData.dic.showmore}>                               
                                                <input type="checkbox" checked={checked2}  onChange={handleChange2}/>
                                                <span className="slider round"></span>
                                           </label>  
                                    </div>

                                    

                                    { checked2 &&
                                    <div>

                                            <div className="form_control">
                                                        <div className="fieldName">Zgoda na publikacje wizerunku?</div>
                                                        <InputCombo items={ [  {v:'0',title: 'Brak info'},  {v:'1',title: 'Tak'} ,  {v:'2',title: 'Nie'}  ] } value={row.publikacja_wizerunku} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="publikacja_wizerunku" placeholder={""} className='   ' req='0'  />
                                            </div>

                                            {
                                                row.publikacja_wizerunku == "1" &&
                                                <div className="form_control">
                                                        <div className="fieldName">Informacje dodatkowe odnośnie zgody (data, numer, ...)</div>
                                                        <InputTextArea  userData={props.userData} value={row.publikacja_wizerunku_info} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="publikacja_wizerunku_info" placeholder={""} className=' w300 ' req='0'  />
                                                </div>
                                            }

                                            <div className="form_split"></div>


                                            <div className="form_control">
                                                        <div className="fieldName">Informacje dodatkowe (szyfrowane / widoczne tylko dla dyrektora)</div>
                                                        <InputTextArea  userData={props.userData} value={row.info} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info" placeholder={""} className=' w300 ' req='0'  />
                                            </div>

                                            <div className="form_split"></div>

                                           

                                            <div className="form_control">
                                                        <div className="fieldName">Informacje wyróżnione, instotne (szyfrowane / widoczne tylko dla dyrektora)</div>
                                                        <InputTextArea  userData={props.userData} value={row.wazne_informacje} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wazne_informacje" placeholder={""} className=' w300 ' req='0'  />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Informacje dla cateringu (wskazówki i zalecenia)</div>
                                                        <InputTextArea  userData={props.userData} value={row.info_catering} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info_catering" placeholder={""} className=' w300 ' req='0'  />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Informacje dodatkowe dla pracowników / opiekunów (widoczne w panelu pracownika)</div>
                                                        <InputTextArea  userData={props.userData} value={row.info_e} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info_e" placeholder={""} className=' w300 ' req='0'  />
                                            </div>

                                    </div>
                                    }


 

                            </div>




                            <div className="form_tab">


                                <div className="form_tab_title">Rozliczenia, płatności:
                                    &nbsp; 
                                    <label className="switch" title={props.userData.dic.showmore}>                               
                                            <input type="checkbox" checked={checked3}  onChange={handleChange3}/>
                                            <span className="slider round"></span>
                                    </label>  
                                </div>



                                { checked3 &&
                                <div>

                                            <div className="form_split"></div>
                                    

                                            <div className="form_control">
                                                        <div className="fieldName">Informacje dodatkowe, które mają się pojawić na rozliczeniu</div>
                                                        <InputTextArea  userData={props.userData} value={row.info_dodatkowe_na_fakturze} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info_dodatkowe_na_fakturze" placeholder={""} className=' w300 ' req='0'  />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Do kogo przypisać saldo za płatności? (Na kogo będą wystawiane faktury lub rachunki)</div>
                                                        <InputCombo items={optionSaldo} userData={props.userData} value={row.op_select} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="op_select" placeholder={""} className=' w300 ' req='0'  />
                                            </div>


                                            <div className="form_split"></div>


                                            <div className="form_control">
                                                        <div className="fieldName">Indywidualny numer rachunku do wpłat (jeśli istnieje / podpisana umowa z bankiem)</div>
                                                        <InputCombo items={optionRach} userData={props.userData} value={row.uq_numer_rachunku_op} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="uq_numer_rachunku_op" placeholder={""} className=' w300 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName"> Nr banku (8 cyfr)</div>
                                                        <InputDecimal  userData={props.userData} value={row.uq_bank} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="uq_bank" placeholder={""} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Kod klienta (4 cyfry)</div>
                                                        <InputDecimal  userData={props.userData} value={row.uq_numer_klienta} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="uq_numer_klienta" placeholder={""} className=' w50 ' req='0'  />
                                            </div>

                                    

                                </div>
                                }




                                </div>




                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>dodaj</div>
                                    &nbsp;&nbsp;
                                    <div className="btn" onClick={props.onBack}    > anuluj</div>
                            </div>




                    </form>


            </div>
    )

}


export default KidNew;


